import React, { useState } from 'react';
import classnames from 'classnames';
import { FleetCapabilities } from '@bringg/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeaf } from '@fortawesome/pro-solid-svg-icons/faLeaf';
import { Button } from '../../../components';

interface Props {
	fleets: Fleet[];
	onSelect?(fleetId: string): void;
	selectedFleet?: Fleet;
}

interface Fleet {
	id: string;
	name: string;
	capabilities?: FleetCapabilities;
}

const FleetsList: React.FC<Props> = ({ fleets, onSelect, selectedFleet }) => {
	const [selected, setSelected] = useState<string>(selectedFleet?.id);
	const handleSelect = ({ id }: Fleet) => {
		if (id !== selected) {
			setSelected(id);
			onSelect(id);
		}
	};
	const isInteractive = !!onSelect;
	return (
		<div className="fleet-list">
			<div className="list-header">Fleets</div>
			<div className="fleet-list-content">
				{fleets.map(fleet => {
					const isGreen = fleet?.capabilities?.is_green;

					return (
						<Button
							key={fleet.id}
							className={classnames('fleet-list-content-item', {
								active: fleet.id === selected,
								'non-interactive': !isInteractive
							})}
							onClick={() => handleSelect(fleet)}
						>
							{fleet.name}
							{isGreen && (
								<span className="green-fleet-icon-container">
									<FontAwesomeIcon icon={faLeaf} />
								</span>
							)}
						</Button>
					);
				})}
			</div>
		</div>
	);
};

export default FleetsList;
